import { ConversationsFilters } from 'ha/constants/ConversationsFilters';
import React from 'react';
import { SvgIconProps } from '@hbf/dsl';
import { defineKey as T } from '@ha/intl';
import {
  ActiveLight,
  ArchiveLight,
  CalendarCheckLight,
  EnvelopeLight,
  HourglassLight,
  ListBullets1Light,
  StarLight,
  StopWatchLight,
  CalendarCheckBold,
  Dislike2Bold,
  HourglassAlternateBold,
  Like2AlternateBold,
  ListBullets1Bold,
  MessagesBubbleSquareTextAlternateBold,
  PaginateFilterMailAlternateBold,
  TimeClockCircle1AlternateBold,
} from '@ha/icons';

export const STATE_NAME = 'inbox';
export const PAGE_SIZE = 10;

export interface InboxFilter {
  type: keyof typeof ConversationsFilters;
  title: string;
  icon: React.ComponentType<SvgIconProps>;
  category: ConversationsFilters;
  displayUnreadBadge: boolean;
  unreadKey: string;
  unreadBadgeKind: 'mint' | 'brand' | 'dark' | 'purple';
}

export const INBOX_FILTERS: { [K in ConversationsFilters]: InboxFilter } = {
  [ConversationsFilters.INBOX]: {
    type: 'INBOX',
    title: T('Inbox'),
    icon: MessagesBubbleSquareTextAlternateBold,
    category: ConversationsFilters.INBOX,
    displayUnreadBadge: true,
    unreadKey: 'inboxUnread',
    unreadBadgeKind: 'mint',
  },
  [ConversationsFilters.FAVORITE]: {
    type: 'FAVORITE',
    title: T('Shortlist'),
    icon: Like2AlternateBold,
    category: ConversationsFilters.FAVORITE,
    displayUnreadBadge: false,
    unreadKey: 'favoritedUnread',
    unreadBadgeKind: 'mint',
  },
  [ConversationsFilters.ARCHIVED]: {
    type: 'ARCHIVED',
    title: T('Archive'),
    icon: Dislike2Bold,
    category: ConversationsFilters.ARCHIVED,
    displayUnreadBadge: false,
    unreadKey: 'archivedUnread',
    unreadBadgeKind: 'mint',
  },
  [ConversationsFilters.PENDING]: {
    type: 'PENDING',
    title: T('Pending'),
    icon: HourglassAlternateBold,
    category: ConversationsFilters.PENDING,
    displayUnreadBadge: true,
    unreadKey: 'pendingUnread',
    unreadBadgeKind: 'brand',
  },
  [ConversationsFilters.PAID]: {
    type: 'PAID',
    title: T('Booking'),
    icon: CalendarCheckBold,
    category: ConversationsFilters.PAID,
    displayUnreadBadge: true,
    unreadKey: 'paidUnread',
    unreadBadgeKind: 'brand',
  },
  [ConversationsFilters.EXPIRED]: {
    type: 'EXPIRED',
    title: T('Expired'),
    icon: TimeClockCircle1AlternateBold,
    category: ConversationsFilters.EXPIRED,
    displayUnreadBadge: true,
    unreadKey: 'expiredUnread',
    unreadBadgeKind: 'brand',
  },
  [ConversationsFilters.ALL]: {
    type: 'ALL',
    title: T('All'),
    icon: ListBullets1Bold,
    category: ConversationsFilters.ALL,
    displayUnreadBadge: false,
    unreadKey: 'allUnread',
    unreadBadgeKind: 'purple',
  },
  [ConversationsFilters.UNREAD]: {
    type: 'UNREAD',
    title: T('Unread'),
    icon: PaginateFilterMailAlternateBold,
    category: ConversationsFilters.UNREAD,
    displayUnreadBadge: false,
    unreadKey: 'allUnread',
    unreadBadgeKind: 'purple',
  },
};

export const INBOX_FILTERS_GROUPS: {
  name: string;
  filters: InboxFilter[];
}[] = [
  {
    name: 'main',
    filters: [
      INBOX_FILTERS[ConversationsFilters.INBOX],
      INBOX_FILTERS[ConversationsFilters.FAVORITE],
      INBOX_FILTERS[ConversationsFilters.ARCHIVED],
    ],
  },
  {
    name: 'secondary',
    filters: [
      INBOX_FILTERS[ConversationsFilters.PENDING],
      INBOX_FILTERS[ConversationsFilters.PAID],
      INBOX_FILTERS[ConversationsFilters.EXPIRED],
    ],
  },
  {
    name: 'rest',
    filters: [
      INBOX_FILTERS[ConversationsFilters.ALL],
      INBOX_FILTERS[ConversationsFilters.UNREAD],
    ],
  },
];

export const MENU_ITEMS: Record<
  ConversationsFilters,
  {
    title: string;
    icon: React.ComponentType<SvgIconProps>;
  }
> = {
  [ConversationsFilters.INBOX]: {
    title: T('Active'),
    icon: ActiveLight,
  },
  [ConversationsFilters.UNREAD]: {
    title: T('Unread'),
    icon: EnvelopeLight,
  },
  [ConversationsFilters.PENDING]: {
    title: T('Pending'),
    icon: HourglassLight,
  },
  [ConversationsFilters.PAID]: {
    title: T('Booked'),
    icon: CalendarCheckLight,
  },
  [ConversationsFilters.FAVORITE]: {
    title: T('Shortlisted'),
    icon: StarLight,
  },
  [ConversationsFilters.EXPIRED]: {
    title: T('Expired'),
    icon: StopWatchLight,
  },
  [ConversationsFilters.ARCHIVED]: {
    title: T('Archived'),
    icon: ArchiveLight,
  },
  [ConversationsFilters.ALL]: {
    title: T('All messages'),
    icon: ListBullets1Light,
  },
};
